const ALUGUEL_CLIENTES = [
  { label: 'Visualizar clientes', data: 'visualizacao', aninhado: false },
  { label: 'Somente do corretor', data: 'visualizacaoSomenteClientesCorretor', aninhado: true, dependenciaVisibilidade: 'visualizacao' },
  { label: 'Cadastrar clientes', data: 'cadastro', aninhado: false },
  { label: 'Alterar clientes', data: 'alteracao', aninhado: false },
  { label: 'Exceto: Nome, CPF/CNPJ, RG e Telefone', data: 'alteracaoClienteComExcecoes', aninhado: true, dependenciaVisibilidade: 'alteracao' },
  { label: 'Exceto: Conta Bancária', data: 'alteracaoClienteComExcecaoContaBancaria', aninhado: true, dependenciaVisibilidade: 'alteracao'},
  { label: 'Remover clientes', data: 'remocao', aninhado: false },
  { label: 'Alterar observações', data: 'alterarObservacoes', aninhado: false },
  { label: 'Somente do corretor', data: 'alterarObservacoesSomenteCorretor', aninhado: true, dependenciaVisibilidade: 'alterarObservacoes' },
  { label: 'Remover observações', data: 'removerObservacoes', aninhado: false },
  { label: 'Imprimir formulários', data: 'geracaoFormularios', aninhado: false },
  { label: 'Alterar funcionário', data: 'alteracaoCorretor', aninhado: false },
  { label: 'Alterar arquivos', data: 'alterarArquivos', aninhado: false }
];
const PERMISSOES_ALUGUEL_CLIENTES = ALUGUEL_CLIENTES.map((item) => { return item.data });
const ALUGUEL_CLIENTES_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao', 'alterarObservacoes', 'removerObservacoes', 'geracaoFormularios', 'alteracaoCorretor', 'alterarArquivos'];

const ALUGUEL_BAIXA = [
  { label: 'Adicionar item ao boleto', data: 'adicionarItemRecibo', aninhado: false },
  { label: 'Remover item de boleto', data: 'removerItemRecibo', aninhado: false },
  { label: 'Gerar boletos/demonstrativos', data: 'gerarBoletos', aninhado: false },
  { label: 'Pagar aluguel', data: 'pagarAluguel', aninhado: false },
  { label: 'Alterar forma pagamento', data: 'alterarFormaPagamentoAluguel', aninhado: true, dependenciaVisibilidade: 'pagarAluguel' },
  { label: 'Conceder desconto', data: 'concederDescontoPagarAluguel', aninhado: true, dependenciaVisibilidade: 'pagarAluguel' },
  { label: 'Cancelar pagamento aluguel', data: 'cancelarAluguel', aninhado: false },
  { label: 'Prorrogar boleto', data: 'prorrogarBoleto', aninhado: false },
  { label: 'Conceder desconto', data: 'concederDescontoProrrogarBoleto', aninhado: true, dependenciaVisibilidade: 'prorrogarBoleto' },
  { label: 'Processar arquivo bancário', data: 'processarArquivoBancario', aninhado: false },
  { label: 'Registrar Cobranças', data: 'registrarCobranca', aninhado: false},
  { label: 'Remover Cobranças Manuais', data: 'removerCobranca', aninhado: false},
  { label: 'Registrar Títulos via API', data: 'registrarTitulosApi', aninhado: false },
  { label: 'Controle de Títulos API', data: 'controleTitulosApi', aninhado: false }
];
const PERMISSOES_ALUGUEL_BAIXA = ALUGUEL_BAIXA.map((item) => { return item.data });
const ALUGUEL_BAIXA_CHECK_ALL = ['adicionarItemRecibo', 'removerItemRecibo', 'gerarBoletos', 'pagarAluguel', 'alterarFormaPagamentoAluguel', 'concederDescontoPagarAluguel', 'cancelarAluguel', 'prorrogarBoleto', 'concederDescontoProrrogarBoleto', 'processarArquivoBancario', 'registrarTitulosApi', 'controleTitulosApi'];

const ALUGUEL_LIBERACAO_REPASSE = [
  { label: 'Adicionar item ao repasse', data: 'adicionarItemRepasse', aninhado: false },
  { label: 'Remover item de repasse', data: 'removerItemRepasse', aninhado: false },
  { label: 'Liberar repasse', data: 'liberarRepasse', aninhado: false },
  { label: 'Alterar forma pagamento', data: 'alterarFormaPagamentoRepasse', aninhado: true, dependenciaVisibilidade: 'liberarRepasse' },
  { label: 'Cancelar repasse', data: 'cancelarRepasse', aninhado: false },
  { label: 'Gerar remessa bancária', data: 'gerarRemessaBancaria', aninhado: false }
];
const PERMISSOES_ALUGUEL_LIBERACAO_REPASSE = ALUGUEL_LIBERACAO_REPASSE.map((item) => { return item.data });
const ALUGUEL_LIBERACAO_REPASSE_CHECK_ALL = ['adicionarItemRepasse', 'removerItemRepasse', 'liberarRepasse', 'alterarFormaPagamentoRepasse', 'cancelarRepasse', 'gerarRemessaBancaria'];

const ALUGUEL_IMOVEIS = [
  { label: 'Visualizar imóveis', data: 'visualizacao', aninhado: false },
  { label: 'Somente do corretor', data: 'visualizacaoSomenteImoveisCorretor', aninhado: true, dependenciaVisibilidade: 'visualizacao' },
  { label: 'Cadastrar imóveis', data: 'cadastro', aninhado: false },
  { label: 'Alterar imóveis', data: 'alteracao', aninhado: false },
  { label: 'Alterar o ID', data: 'alterarId', aninhado: true, dependenciaVisibilidade: 'alteracao' },
  { label: 'Remover imóveis', data: 'remocao', aninhado: false },
  { label: 'Alterar observações', data: 'alterarObservacoes', aninhado: false },
  { label: 'Somente do corretor', data: 'alterarObservacoesSomenteCorretor', aninhado: true, dependenciaVisibilidade: 'alterarObservacoes' },
  { label: 'Remover observações', data: 'removerObservacoes', aninhado: false },
  { label: 'Alterar reservas', data: 'alterarReservas', aninhado: false },
  { label: 'Imprimir formulários', data: 'geracaoFormularios', aninhado: false },
  { label: 'Alterar funcionário', data: 'alteracaoCorretor', aninhado: false },
  { label: 'Alterar arquivos', data: 'alterarArquivos', aninhado: false }
];
const PERMISSOES_ALUGUEL_IMOVEIS = ALUGUEL_IMOVEIS.map((item) => { return item.data });
const ALUGUEL_IMOVEIS_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao', 'alterarObservacoes', 'removerObservacoes', 'alterarReservas', 'geracaoFormularios', 'alteracaoCorretor', 'alterarArquivos'];

const ALUGUEL_CONTRATOS = [
  { label: 'Visualizar contratos', data: 'visualizacao', aninhado: false },
  { label: 'Somente do corretor', data: 'visualizacaoSomenteContratosCorretor', aninhado: true, dependenciaVisibilidade: 'visualizacao' },
  { label: 'Cadastrar contratos', data: 'cadastro', aninhado: false },
  { label: 'Alterar contratos', data: 'alteracao', aninhado: false },
  { label: 'Alterar o ID', data: 'alterarId', aninhado: true, dependenciaVisibilidade: 'alteracao' },
  { label: 'Remover contratos', data: 'remocao', aninhado: false },
  { label: 'Alterar observações', data: 'alterarObservacoes', aninhado: false },
  { label: 'Somente do corretor', data: 'alterarObservacoesSomenteCorretor', aninhado: true, dependenciaVisibilidade: 'alterarObservacoes' },
  { label: 'Remover observações', data: 'removerObservacoes', aninhado: false },
  { label: 'Imprimir formulários', data: 'geracaoFormularios', aninhado: false },
  { label: 'Alterar funcionário', data: 'alteracaoCorretor', aninhado: false },
  { label: 'Alterar arquivos', data: 'alterarArquivos', aninhado: false },
  { label: 'Forçar Conclusão da Vistoria', data: 'forcarConclusaoVistoria', aninhado: false },
  { label: 'Cancelar Vistoria Concluída', data: 'cancelarVistoria', aninhado: false },
  { label: 'DIMOB', data: 'visualizarDimob', aninhado: false}
];
const PERMISSOES_ALUGUEL_CONTRATOS = ALUGUEL_CONTRATOS.map((item) => { return item.data });
const ALUGUEL_CONTRATOS_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao', 'alterarObservacoes', 'removerObservacoes', 'geracaoFormularios', 'alteracaoCorretor', 'alterarArquivos', 'forcarConclusaoVistoria', 'cancelarVistoria'];

const ALUGUEL_REAJUSTE = [
  { label: 'Reajustar', data: 'reajustarAluguel', aninhado: false },
  { label: 'Cancelar reajuste', data: 'cancelarReajuste', aninhado: false },
  { label: 'Renovar', data: 'renovarAluguel', aninhado: false },
  { label: 'Cancelar renovação', data: 'cancelarRenovacao', aninhado: false },
  { label: 'Prorrogar', data: 'prorrogarAluguel', aninhado: false },
  { label: 'Cancelar prorrogação', data: 'cancelarProrrogacao', aninhado: false }
];
const PERMISSOES_ALUGUEL_REAJUSTE = ALUGUEL_REAJUSTE.map((item) => { return item.data });
const ALUGUEL_REAJUSTE_CHECK_ALL = ['reajustarAluguel', 'cancelarReajuste', 'renovarAluguel', 'cancelarRenovacao', 'prorrogarAluguel', 'cancelarProrrogacao'];

const ALUGUEL_VENCIMENTO = [
  { label: 'Alterar vencimento', data: 'alterarVencimentoAluguel', aninhado: false },
  { label: 'Alterar carência', data: 'alterarCarenciaAluguel', aninhado: false },
  { label: 'Alterar taxa de adm.', data: 'alterarTaxaDeAdmAluguel', aninhado: false },
  { label: 'Alterar valor do aluguel', data: 'alterarValorAluguel', aninhado: false }
];
const PERMISSOES_ALUGUEL_VENCIMENTO = ALUGUEL_VENCIMENTO.map((item) => { return item.data });
const ALUGUEL_VENCIMENTO_CHECK_ALL = ['alterarVencimentoAluguel', 'alterarCarenciaAluguel', 'alterarTaxaDeAdmAluguel', 'alterarValorAluguel'];

const RELATORIOS_CONTRATOS = [
  { label: 'Contratos ativos', data: 'relatorioContratosAtivos', aninhado: false },
  { label: 'Novos', data: 'relatorioContratosNovos', aninhado: false },
  { label: 'Renovados', data: 'relatorioContratosRenovados', aninhado: false },
  { label: 'Vencidos/À vencer', data: 'relatorioContratosVencidos', aninhado: false },
  { label: 'Finalizados', data: 'relatorioContratosFinalizados', aninhado: false },
  { label: 'Efetivados', data: 'relatorioContratosEfetivados', aninhado: false },
  { label: 'Declarar IR', data: 'relatorioContratosDeclararIr', aninhado: false },
  { label: 'Prorrogados', data: 'relatorioContratosProrrogados', aninhado: false }
];
const PERMISSOES_RELATORIOS_CONTRATOS = RELATORIOS_CONTRATOS.map((item) => { return item.data });
const RELATORIOS_CONTRATOS_CHECK_ALL = ['relatorioContratosAtivos', 'relatorioContratosNovos', 'relatorioContratosRenovados', 'relatorioContratosVencidos', 'relatorioContratosFinalizados', 'relatorioContratosEfetivados', 'relatorioContratosDeclararIr', 'relatorioContratosProrrogados'];

const RELATORIOS_IMOVEIS = [
  { label: 'Imóveis captados por captador', data: 'relatorioImoveisCaptadosPorCaptador', aninhado: false },
  { label: 'Imóveis captados por tipo de imóvel', data: 'relatorioImoveisCaptadosPorTipoDeImovel', aninhado: false },
  { label: 'Imóveis para aluguel', data: 'relatorioImoveisParaAluguel', aninhado: false },
  { label: 'Imóveis aluguel Por Tipo de Imóvel', data: 'relatorioImoveisAluguelPorTipoDeImovel', aninhado: false },
  { label: 'Imóveis por cliente', data: 'relatorioImoveisPorCliente', aninhado: false },
  { label: 'Imóveis por condomínio', data: 'relatorioImoveisPorCondominio', aninhado: false },
  { label: 'Imóveis com placa', data: 'relatorioImoveisComPlaca', aninhado: false },
  { label: 'Imóveis sem placa', data: 'relatorioImoveisSemPlaca', aninhado: false },
  { label: 'Imóveis sem fotos', data: 'relatorioImoveisSemFotos', aninhado: false },
  { label: 'Imóveis reservados', data: 'relatorioImoveisReservados', aninhado: false },
  { label: 'Imóveis publicados no site', data: 'relatorioImoveisPublicadosSite', aninhado: false },
  { label: 'Imóveis com E-mail de Acompanhamento', data: 'relatorioImoveisAcompanhamento', aninhado: false },
  { label: 'Resumo das administradoras', data: 'relatorioResumoAdministradoras', aninhado: false },
  { label: 'Matrículas dos imóveis', data: 'relatorioMatriculasImoveis', aninhado: false },
  { label: 'Visitas por período', data: 'relatorioVisitasPorPeriodo', aninhado: false },
  { label: 'Vistorias por período', data: 'relatorioVistoriasPorPeriodo', aninhado: false }
];
const PERMISSOES_RELATORIOS_IMOVEIS = RELATORIOS_IMOVEIS.map((item) => { return item.data });
const RELATORIOS_IMOVEIS_CHECK_ALL = ['relatorioImoveisCaptadosPorCaptador', 'relatorioImoveisCaptadosPorTipoDeImovel', 'relatorioImoveisParaAluguel', 'relatorioImoveisAluguelPorTipoDeImovel' , 'relatorioImoveisPorCliente', 'relatorioImoveisPorCondominio', 'relatorioImoveisComPlaca', 'relatorioImoveisSemPlaca', 'relatorioImoveisSemFotos', 'relatorioImoveisReservados', 'relatorioResumoAdministradoras', 'relatorioMatriculasImoveis', 'relatorioVisitasPorPeriodo', 'relatorioVistoriasPorPeriodo'];

const RELATORIOS_FINANCEIROS = [
  { label: 'Previsão de repasses', data: 'relatorioPrevisaoRepasses', aninhado: false },
  { label: 'Previsão de recebimentos', data: 'relatorioPrevisaoRecebimentos', aninhado: false },
  { label: 'Repasses realizados', data: 'relatorioRepassesRealizados', aninhado: false },
  { label: 'Repasses atrasados', data: 'relatorioRepassesAtrasados', aninhado: false },
  { label: 'Repasses efetivados por período', data: 'relatorioRepassesEfetivadosPeriodo', aninhado: false },
  { label: 'Aluguéis recebidos', data: 'relatorioAlugueisRecebidos', aninhado: false },
  { label: 'Aluguéis atrasados', data: 'relatorioAlugueisAtrasados', aninhado: false },
  { label: 'Boletos avulsos', data: 'relatorioBoletosAvulsos', aninhado: false },
  { label: 'Remessas geradas', data: 'relatorioRemessasGeradas', aninhado: false },
  { label: 'Desempenho de locação', data: 'relatorioDesempenhoLocacao', aninhado: false },
  { label: 'Resumo da carteira', data: 'relatorioResumoCarteira', aninhado: false }
];
const PERMISSOES_RELATORIOS_FINANCEIROS = RELATORIOS_FINANCEIROS.map((item) => { return item.data });
const RELATORIOS_FINANCEIROS_CHECK_ALL = ['relatorioPrevisaoRepasses', 'relatorioPrevisaoRecebimentos', 'relatorioRepassesRealizados', 'relatorioRepassesEfetivadosPeriodo', 'relatorioRepassesAtrasados', 'relatorioAlugueisRecebidos', 'relatorioAlugueisAtrasados', 'relatorioBoletosAvulsos', 'relatorioRemessasGeradas', 'relatorioDesempenhoLocacao', 'relatorioResumoCarteira'];

const VENDA_CLIENTES = [
  { label: 'Visualizar clientes', data: 'visualizacao', aninhado: false },
  { label: 'Somente do corretor', data: 'visualizacaoSomenteClientesCorretor', aninhado: true, dependenciaVisibilidade: 'visualizacao' },
  { label: 'Cadastrar clientes', data: 'cadastro', aninhado: false },
  { label: 'Alterar clientes', data: 'alteracao', aninhado: false },
  { label: 'Exceto: Nome, CPF/CNPJ, RG e Telefone', data: 'alteracaoClienteComExcecoes', aninhado: true, dependenciaVisibilidade: 'alteracao' },
  { label: 'Exceto: Conta Bancária', data: 'alteracaoClienteComExcecaoContaBancaria', aninhado: true, dependenciaVisibilidade: 'alteracao'},
  { label: 'Remover clientes', data: 'remocao', aninhado: false },
  { label: 'Alterar observações', data: 'alterarObservacoes', aninhado: false },
  { label: 'Somente do corretor', data: 'alterarObservacoesSomenteCorretor', aninhado: true, dependenciaVisibilidade: 'alterarObservacoes' },
  { label: 'Remover observações', data: 'removerObservacoes', aninhado: false },
  { label: 'Imprimir formulários', data: 'geracaoFormularios', aninhado: false },
  { label: 'Alterar funcionário', data: 'alteracaoCorretor', aninhado: false },
  { label: 'Alterar arquivos', data: 'alterarArquivos', aninhado: false }
];
const PERMISSOES_VENDA_CLIENTES = VENDA_CLIENTES.map((item) => { return item.data });
const VENDA_CLIENTES_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao', 'alterarObservacoes', 'removerObservacoes', 'geracaoFormularios', 'alteracaoCorretor', 'alterarArquivos'];

const VENDA_IMOVEIS = [
  { label: 'Visualizar imóveis', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar imóveis', data: 'cadastro', aninhado: false },
  { label: 'Alterar imóveis', data: 'alteracao', aninhado: false },
  { label: 'Alterar o ID', data: 'alterarId', aninhado: true, dependenciaVisibilidade: 'alteracao' },
  { label: 'Remover imóveis', data: 'remocao', aninhado: false },
  { label: 'Alterar observações', data: 'alterarObservacoes', aninhado: false },
  { label: 'Somente do corretor', data: 'alterarObservacoesSomenteCorretor', aninhado: true, dependenciaVisibilidade: 'alterarObservacoes' },
  { label: 'Remover observações', data: 'removerObservacoes', aninhado: false },
  { label: 'Alterar reservas', data: 'alterarReservas', aninhado: false },
  { label: 'Imprimir formulários', data: 'geracaoFormularios', aninhado: false },
  { label: 'Alterar funcionário', data: 'alteracaoCorretor', aninhado: false },
  { label: 'Alterar arquivos', data: 'alterarArquivos', aninhado: false }
];
const PERMISSOES_VENDA_IMOVEIS = VENDA_IMOVEIS.map((item) => { return item.data });
const VENDA_IMOVEIS_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao', 'alterarObservacoes', 'removerObservacoes', 'alterarReservas', 'geracaoFormularios', 'alteracaoCorretor', 'alterarArquivos'];

const VENDA_CONTRATOS = [
  { label: 'Visualizar contratos', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar contratos', data: 'cadastro', aninhado: false },
  { label: 'Alterar contratos', data: 'alteracao', aninhado: false },
  { label: 'Remover contratos', data: 'remocao', aninhado: false },
  { label: 'Alterar observações', data: 'alterarObservacoes', aninhado: false },
  { label: 'Somente do corretor', data: 'alterarObservacoesSomenteCorretor', aninhado: true, dependenciaVisibilidade: 'alterarObservacoes' },
  { label: 'Remover observações', data: 'removerObservacoes', aninhado: false },
  { label: 'Imprimir formulários', data: 'geracaoFormularios', aninhado: false },
  { label: 'Somente comissões do corretor', data: 'visualizacaoSomenteComissoesCorretor', aninhado: false },
  { label: 'Alterar funcionário', data: 'alteracaoCorretor', aninhado: false },
  { label: 'Alterar arquivos', data: 'alterarArquivos', aninhado: false }
];
const PERMISSOES_VENDA_CONTRATOS = VENDA_CONTRATOS.map((item) => { return item.data });
const VENDA_CONTRATOS_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao', 'alterarObservacoes', 'removerObservacoes', 'geracaoFormularios', 'visualizacaoSomenteComissoesCorretor', 'alteracaoCorretor', 'alterarArquivos'];

const VENDA_RELATORIOS = [
  { label: 'Relatórios de captação', data: 'captacoesVisualizacao', aninhado: false },
  { label: 'Relatórios de comissões', data: 'comissoesVisualizacao', aninhado: false },
  { label: 'Somente do corretor', data: 'visualizacaoSomenteClientesCorretor', aninhado: true, dependenciaVisibilidade: 'comissoesVisualizacao' },
  { label: 'Relatórios de clientes', data: 'clientesVisualizacao', aninhado: false },
  { label: 'Relatórios de imóveis', data: 'imoveisVisualizacao', aninhado: false },
  { label: 'Relatórios de pretendentes', data: 'pretendentesVisualizacao', aninhado: false }
];
const VENDA_RELATORIOS_CHECK_ALL = ['captacoesVisualizacao', 'comissoesVisualizacao', 'clientesVisualizacao', 'imoveisVisualizacao', 'pretendentesVisualizacao'];

const FINANCEIRO_CONTAS_RECEBER = [
  { label: 'Visualizar contas a receber', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar contas a receber', data: 'cadastro', aninhado: false },
  { label: 'Alterar contas a receber', data: 'alteracao', aninhado: false },
  { label: 'Aprovar/Desaprovar contas a receber', data: 'aprovarDesaprovarConta', aninhado: false },
  { label: 'Reconhecer contas a receber', data: 'reconhecerConta', aninhado: false },
  { label: 'Cancelar contas a receber', data: 'cancelarConta', aninhado: false },
  { label: 'Remover contas a receber', data: 'remocao', aninhado: false }
];
const PERMISSOES_FINANCEIRO_CONTAS_RECEBER = FINANCEIRO_CONTAS_RECEBER.map((item) => { return item.data });
const FINANCEIRO_CONTAS_RECEBER_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'aprovarDesaprovarConta', 'cancelarConta', 'remocao'];

const FINANCEIRO_LANCAMENTOS_RECEBER = [
  { label: 'Cadastrar lançamento', data: 'cadastro', aninhado: false },
  { label: 'Alterar lançamento', data: 'alteracao', aninhado: false },
  { label: 'Pagar lançamento', data: 'pagarLancamento', aninhado: false },
  { label: 'Cancelar lançamento', data: 'cancelarLancamento', aninhado: false },
  { label: 'Remover lançamento', data: 'remocao', aninhado: false }
];
const PERMISSOES_FINANCEIRO_LANCAMENTOS_RECEBER = FINANCEIRO_LANCAMENTOS_RECEBER.map((item) => { return item.data });
const FINANCEIRO_LANCAMENTOS_RECEBER_CHECK_ALL = ['cadastro', 'alteracao', 'pagarLancamento', 'cancelarLancamento', 'remocao'];

const FINANCEIRO_CONTAS_PAGAR = [
  { label: 'Visualizar contas a pagar', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar contas a pagar', data: 'cadastro', aninhado: false },
  { label: 'Alterar contas a pagar', data: 'alteracao', aninhado: false },
  { label: 'Aprovar/Desaprovar contas a pagar', data: 'aprovarDesaprovarConta', aninhado: false },
  { label: 'Reconhecer contas a pagar', data: 'reconhecerConta', aninhado: false },
  { label: 'Cancelar contas a pagar', data: 'cancelarConta', aninhado: false },
  { label: 'Remover contas a pagar', data: 'remocao', aninhado: false }
];
const PERMISSOES_FINANCEIRO_CONTAS_PAGAR = FINANCEIRO_CONTAS_PAGAR.map((item) => { return item.data });
const FINANCEIRO_CONTAS_PAGAR_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'aprovarDesaprovarConta', 'cancelarConta', 'remocao'];

const FINANCEIRO_LANCAMENTOS_PAGAR = [
  { label: 'Cadastrar lançamento', data: 'cadastro', aninhado: false },
  { label: 'Alterar lançamento', data: 'alteracao', aninhado: false },
  { label: 'Pagar lançamento', data: 'pagarLancamento', aninhado: false },
  { label: 'Cancelar lançamento', data: 'cancelarLancamento', aninhado: false },
  { label: 'Remover lançamento', data: 'remocao', aninhado: false }
];
const PERMISSOES_FINANCEIRO_LANCAMENTOS_PAGAR = FINANCEIRO_LANCAMENTOS_PAGAR.map((item) => { return item.data });
const FINANCEIRO_LANCAMENTOS_PAGAR_CHECK_ALL = ['cadastro', 'alteracao', 'pagarLancamento', 'cancelarLancamento', 'remocao'];

const FINANCEIRO_CAIXA = [
  { label: 'Abrir/Fechar caixa', data: 'abrirFecharCaixa', aninhado: false },
  { label: 'Visualizar histórico', data: 'visualizarHistoricoCaixa', aninhado: false }
];
const PERMISSOES_FINANCEIRO_CAIXA = FINANCEIRO_CAIXA.map((item) => { return item.data });
const FINANCEIRO_CAIXA_CHECK_ALL = ['abrirFecharCaixa', 'visualizarHistoricoCaixa'];

const FINANCEIRO_FORNECEDORES = [
  { label: 'Visualizar fornecedores', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar fornecedores', data: 'cadastro', aninhado: false },
  { label: 'Alterar fornecedores', data: 'alteracao', aninhado: false },
  { label: 'Remover fornecedores', data: 'remocao', aninhado: false }
];
const PERMISSOES_FINANCEIRO_FORNECEDORES = FINANCEIRO_FORNECEDORES.map((item) => { return item.data });
const FINANCEIRO_FORNECEDORES_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao'];

const FINANCEIRO_PLANOS_CONTA = [
  { label: 'Visualizar planos de conta', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar planos de conta', data: 'cadastro', aninhado: false },
  { label: 'Alterar planos de conta', data: 'alteracao', aninhado: false },
  { label: 'Remover planos de conta', data: 'remocao', aninhado: false }
];
const PERMISSOES_FINANCEIRO_PLANOS_CONTA = FINANCEIRO_PLANOS_CONTA.map((item) => { return item.data });
const FINANCEIRO_PLANOS_CONTA_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao'];

const FINANCEIRO_RELATORIOS = [
  { label: 'Contas Pagas', data: 'relatorioContasPagas', aninhado: false },
  { label: 'Contas a Pagar', data: 'relatorioContasAPagar', aninhado: false },
  { label: 'Contas a Pagar Vencidas', data: 'relatorioContasAPagarVencidas', aninhado: false },
  { label: 'Contas Recebidas', data: 'relatorioContasRecebidas', aninhado: false },
  { label: 'Contas a Receber', data: 'relatorioContasAReceber', aninhado: false },
  { label: 'Contas a Receber Vencidas', data: 'relatorioContasAReceberVencidas', aninhado: false },
  { label: 'Cheques', data: 'relatorioCheques', aninhado: false },
];
const PERMISSOES_FINANCEIRO_RELATORIOS = FINANCEIRO_RELATORIOS.map(item => item.data);
const FINANCEIRO_RELATORIOS_CHECK_ALL = [...PERMISSOES_FINANCEIRO_RELATORIOS];

const FINANCEIRO_GRUPOS_CONTA = [
  { label: 'Visualizar', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar', data: 'cadastro', aninhado: false },
  { label: 'Alterar', data: 'alteracao', aninhado: false },
  { label: 'Remover', data: 'remocao', aninhado: false }
];
const PERMISSOES_FINANCEIRO_GRUPOS_CONTA = FINANCEIRO_GRUPOS_CONTA.map((item) => { return item.data });
const FINANCEIRO_GRUPOS_CONTA_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao'];

const CONFIGURACOES_PRETENDENTES = [
  { label: 'Visualizar pretendentes', data: 'visualizacao', aninhado: false },
  { label: 'Somente do corretor', data: 'visualizacaoSomenteClientesCorretor', aninhado: true, dependenciaVisibilidade: 'visualizacao' },
  { label: 'Cadastrar pretendentes', data: 'cadastro', aninhado: false },
  { label: 'Alterar pretendentes', data: 'alteracao', aninhado: false },
  { label: 'Remover pretendentes', data: 'remocao', aninhado: false }
];
const PERMISSOES_CONFIGURACOES_PRETENDENTES = CONFIGURACOES_PRETENDENTES.map((item) => { return item.data });
const CONFIGURACOES_PRETENDENTES_CHECK_ALL = ['visualizacao', 'visualizacaoSomenteClientesCorretor', 'cadastro', 'alteracao', 'remocao'];

const CONFIGURACOES_CONDOMINIOS = [
  { label: 'Visualizar condomínios', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar condomínios', data: 'cadastro', aninhado: false },
  { label: 'Alterar condomínios', data: 'alteracao', aninhado: false },
  { label: 'Remover condomínios', data: 'remocao', aninhado: false }
];
const PERMISSOES_CONFIGURACOES_CONDOMINIOS = CONFIGURACOES_CONDOMINIOS.map((item) => { return item.data });
const CONFIGURACOES_CONDOMINIOS_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao'];

const CONFIGURACOES_ADMINISTRADORAS = [
  { label: 'Visualizar administradoras', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar administradoras', data: 'cadastro', aninhado: false },
  { label: 'Alterar administradoras', data: 'alteracao', aninhado: false },
  { label: 'Remover administradoras', data: 'remocao', aninhado: false }
];
const PERMISSOES_CONFIGURACOES_ADMINISTRADORAS = CONFIGURACOES_ADMINISTRADORAS.map((item) => { return item.data });
const CONFIGURACOES_ADMINISTRADORAS_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao'];

const CONFIGURACOES_USUARIOS = [
  { label: 'Visualizar usuários', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar usuários', data: 'cadastro', aninhado: false },
  { label: 'Alterar usuários', data: 'alteracao', aninhado: false },
  { label: 'Remover usuários', data: 'remocao', aninhado: false },
  { label: 'Alterar permissões', data: 'alteracaoPermissoes', aninhado: false }
];
const PERMISSOES_CONFIGURACOES_USUARIOS = CONFIGURACOES_USUARIOS.map((item) => { return item.data });
const CONFIGURACOES_USUARIOS_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao', 'alteracaoPermissoes'];

const CONFIGURACOES_PERFIS = [
  { label: 'Visualizar perfis', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar perfis', data: 'cadastro', aninhado: false },
  { label: 'Alterar perfis', data: 'alteracao', aninhado: false },
  { label: 'Remover perfis', data: 'remocao', aninhado: false }
];
const PERMISSOES_CONFIGURACOES_PERFIS = CONFIGURACOES_PERFIS.map((item) => { return item.data });
const CONFIGURACOES_PERFIS_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao'];

const CONFIGURACOES_PLACAS = [
  { label: 'Visualizar placas', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar placas', data: 'cadastro', aninhado: false },
  { label: 'Alterar placas', data: 'alteracao', aninhado: false },
  { label: 'Remover placas', data: 'remocao', aninhado: false }
];
const PERMISSOES_CONFIGURACOES_PLACAS = CONFIGURACOES_PLACAS.map((item) => { return item.data });
const CONFIGURACOES_PLACAS_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao'];

const CONFIGURACOES_CONTAS = [
  { label: 'Visualizar contas bancárias', data: 'visualizacao', aninhado: false },
  { label: 'Cadastrar contas bancárias', data: 'cadastro', aninhado: false },
  { label: 'Alterar contas bancárias', data: 'alteracao', aninhado: false },
  { label: 'Remover contas bancárias', data: 'remocao', aninhado: false }
];
const PERMISSOES_CONFIGURACOES_CONTAS = CONFIGURACOES_CONTAS.map((item) => { return item.data });
const CONFIGURACOES_CONTAS_CHECK_ALL = ['visualizacao', 'cadastro', 'alteracao', 'remocao'];

const CONFIGURACOES_PORTAIS = [
  { label: 'Visualizar imóveis publicados', data: 'visualizacao', aninhado: false },
  { label: 'Alterar imóveis publicados', data: 'alteracao', aninhado: false }
];
const PERMISSOES_CONFIGURACOES_PORTAIS = CONFIGURACOES_PORTAIS.map((item) => { return item.data });
const CONFIGURACOES_PORTAIS_CHECK_ALL = ['visualizacao', 'alteracao'];

const CONFIGURACOES_LOGS = [
  { label: 'Visualizar logs de acesso', data: 'visualizacao', aninhado: false }
];
const PERMISSOES_CONFIGURACOES_LOGS = CONFIGURACOES_LOGS.map((item) => { return item.data });
const CONFIGURACOES_LOGS_CHECK_ALL = ['visualizacao'];

const CONFIGURACOES_VISITAS = [
  { label: 'Alterar funcionário', data: 'alteracaoCorretor', aninhado: false }
];
const PERMISSOES_CONFIGURACOES_VISITAS = CONFIGURACOES_VISITAS.map((item) => { return item.data });
const CONFIGURACOES_VISITAS_CHECK_ALL = ['alteracaoCorretor'];

const CONFIGURACOES_SISTEMA = [
  //{ label: 'Exibir popup ao salvar arquivo', data: '', aninhado: false },
  { label: 'Gerenciar diretório/formulários', data: 'alterarDiretorioFormularios', aninhado: false },
  { label: 'Alterar Parâmetros', data: 'alterarParametros', aninhado: false },
];
const PERMISSOES_CONFIGURACOES_SISTEMA = CONFIGURACOES_SISTEMA.map((item) => { return item.data });
const CONFIGURACOES_SISTEMA_CHECK_ALL = ['alterarDiretorioFormularios'];

export default {
  ALUGUEL_CLIENTES,
  PERMISSOES_ALUGUEL_CLIENTES,
  ALUGUEL_CLIENTES_CHECK_ALL,

  ALUGUEL_BAIXA,
  PERMISSOES_ALUGUEL_BAIXA,
  ALUGUEL_BAIXA_CHECK_ALL,

  ALUGUEL_LIBERACAO_REPASSE,
  PERMISSOES_ALUGUEL_LIBERACAO_REPASSE,
  ALUGUEL_LIBERACAO_REPASSE_CHECK_ALL,

  ALUGUEL_IMOVEIS,
  PERMISSOES_ALUGUEL_IMOVEIS,
  ALUGUEL_IMOVEIS_CHECK_ALL,

  ALUGUEL_CONTRATOS,
  PERMISSOES_ALUGUEL_CONTRATOS,
  ALUGUEL_CONTRATOS_CHECK_ALL,

  ALUGUEL_REAJUSTE,
  PERMISSOES_ALUGUEL_REAJUSTE,
  ALUGUEL_REAJUSTE_CHECK_ALL,

  ALUGUEL_VENCIMENTO,
  PERMISSOES_ALUGUEL_VENCIMENTO,
  ALUGUEL_VENCIMENTO_CHECK_ALL,

  RELATORIOS_CONTRATOS,
  PERMISSOES_RELATORIOS_CONTRATOS,
  RELATORIOS_CONTRATOS_CHECK_ALL,

  RELATORIOS_IMOVEIS,
  PERMISSOES_RELATORIOS_IMOVEIS,
  RELATORIOS_IMOVEIS_CHECK_ALL,

  RELATORIOS_FINANCEIROS,
  PERMISSOES_RELATORIOS_FINANCEIROS,
  RELATORIOS_FINANCEIROS_CHECK_ALL,

  VENDA_CLIENTES,
  PERMISSOES_VENDA_CLIENTES,
  VENDA_CLIENTES_CHECK_ALL,

  VENDA_IMOVEIS,
  PERMISSOES_VENDA_IMOVEIS,
  VENDA_IMOVEIS_CHECK_ALL,

  VENDA_CONTRATOS,
  PERMISSOES_VENDA_CONTRATOS,
  VENDA_CONTRATOS_CHECK_ALL,

  VENDA_RELATORIOS,
  VENDA_RELATORIOS_CHECK_ALL,

  FINANCEIRO_CONTAS_RECEBER,
  PERMISSOES_FINANCEIRO_CONTAS_RECEBER,
  FINANCEIRO_CONTAS_RECEBER_CHECK_ALL,

  FINANCEIRO_LANCAMENTOS_RECEBER,
  PERMISSOES_FINANCEIRO_LANCAMENTOS_RECEBER,
  FINANCEIRO_LANCAMENTOS_RECEBER_CHECK_ALL,

  FINANCEIRO_CONTAS_PAGAR,
  PERMISSOES_FINANCEIRO_CONTAS_PAGAR,
  FINANCEIRO_CONTAS_PAGAR_CHECK_ALL,

  FINANCEIRO_LANCAMENTOS_PAGAR,
  PERMISSOES_FINANCEIRO_LANCAMENTOS_PAGAR,
  FINANCEIRO_LANCAMENTOS_PAGAR_CHECK_ALL,

  FINANCEIRO_CAIXA,
  PERMISSOES_FINANCEIRO_CAIXA,
  FINANCEIRO_CAIXA_CHECK_ALL,

  FINANCEIRO_FORNECEDORES,
  PERMISSOES_FINANCEIRO_FORNECEDORES,
  FINANCEIRO_FORNECEDORES_CHECK_ALL,

  FINANCEIRO_PLANOS_CONTA,
  PERMISSOES_FINANCEIRO_PLANOS_CONTA,
  FINANCEIRO_PLANOS_CONTA_CHECK_ALL,

  FINANCEIRO_GRUPOS_CONTA,
  PERMISSOES_FINANCEIRO_GRUPOS_CONTA,
  FINANCEIRO_GRUPOS_CONTA_CHECK_ALL,

  FINANCEIRO_RELATORIOS,
  PERMISSOES_FINANCEIRO_RELATORIOS,
  FINANCEIRO_RELATORIOS_CHECK_ALL,

  CONFIGURACOES_PRETENDENTES,
  PERMISSOES_CONFIGURACOES_PRETENDENTES,
  CONFIGURACOES_PRETENDENTES_CHECK_ALL,

  CONFIGURACOES_CONDOMINIOS,
  PERMISSOES_CONFIGURACOES_CONDOMINIOS,
  CONFIGURACOES_CONDOMINIOS_CHECK_ALL,

  CONFIGURACOES_ADMINISTRADORAS,
  PERMISSOES_CONFIGURACOES_ADMINISTRADORAS,
  CONFIGURACOES_ADMINISTRADORAS_CHECK_ALL,

  CONFIGURACOES_USUARIOS,
  PERMISSOES_CONFIGURACOES_USUARIOS,
  CONFIGURACOES_USUARIOS_CHECK_ALL,

  CONFIGURACOES_PERFIS,
  PERMISSOES_CONFIGURACOES_PERFIS,
  CONFIGURACOES_PERFIS_CHECK_ALL,

  CONFIGURACOES_PLACAS,
  PERMISSOES_CONFIGURACOES_PLACAS,
  CONFIGURACOES_PLACAS_CHECK_ALL,

  CONFIGURACOES_CONTAS,
  PERMISSOES_CONFIGURACOES_CONTAS,
  CONFIGURACOES_CONTAS_CHECK_ALL,

  CONFIGURACOES_PORTAIS,
  PERMISSOES_CONFIGURACOES_PORTAIS,
  CONFIGURACOES_PORTAIS_CHECK_ALL,

  CONFIGURACOES_LOGS,
  PERMISSOES_CONFIGURACOES_LOGS,
  CONFIGURACOES_LOGS_CHECK_ALL,

  CONFIGURACOES_VISITAS,
  PERMISSOES_CONFIGURACOES_VISITAS,
  CONFIGURACOES_VISITAS_CHECK_ALL,

  CONFIGURACOES_SISTEMA,
  PERMISSOES_CONFIGURACOES_SISTEMA,
  CONFIGURACOES_SISTEMA_CHECK_ALL
};